;(function () {
  'use strict'

  angular.module('contrast.settings.groups').controller('GroupCtrl', GroupCtrl)

  function GroupCtrl(
    $scope,
    $timeout,
    $translate,
    dialogs,
    csTemplates,
    logger,
    groupsApiConfig,
    sharedGroupService,
    ErrorService,
    PromiseService
  ) {
    'ngInject'

    var translGlobal = {
      title_all_roles: $translate.instant('title_all_roles')
    }

    var _searchKeywords = ''
    var quickFiltersPromise = null
    var lastSearch = null
    var deleteGroupTemplateUrl = 'views/settings/group/template/delete.tpl.html'

    function init() {
      $scope.data.loadPromise = _loadGroups($scope.data.numPerLoad, 0)
      _getQuickFilters()
    }

    angular.extend($scope, {
      searchKeywords: searchKeywords,
      data: {
        numPerLoad: 10,
        loadPromise: null,
        busy: false,
        custom_groups: [],
        readonly_groups: [],
        row: 'name',
        total_custom: 0,
        total_predefined: 0
      },
      quickFilters: [],
      selectedQuickFilter: {
        /*TODO i18n-083 */
        name: translGlobal.title_all_roles,
        filterType: 'ALL',
        count: '?'
      },
      link_orgUsersAndGroups: $translate.instant('link_orgUsersAndGroups')
    })

    angular.extend($scope, {
      order: order,
      loadByScroll: loadByScroll,
      quickFilterSelect: quickFilterSelect,
      showAllApps: showAllApps,

      deleteGroup: deleteGroup
    })

    function _loadGroups(limit, offset) {
      if (lastSearch) {
        PromiseService.cancelPromise(lastSearch)
      }

      lastSearch = groupsApiConfig.getGroups(
        'users,applications',
        limit,
        offset,
        searchKeywords(),
        $scope.data.row,
        $scope.selectedQuickFilter.filterType
      )

      $scope.data.busy = true

      return lastSearch
        .then(function (response) {
          var data = response.data

          $scope.data.busy = false

          sharedGroupService.formatOrganizationGroups(
            data.predefined_groups.groups
          )
          $scope.data.readonly_groups = data.predefined_groups.groups
          $scope.data.total_predefined = data.predefined_groups.count

          $scope.data.total_custom = data.custom_groups.count
          _.each(data.custom_groups.groups, function (group) {
            _.extend(group, { limit: 3 })
          })
          $scope.data.custom_groups = $scope.data.custom_groups.concat(
            data.custom_groups.groups
          )

          $timeout(function () {
            $scope.$emit('triggerScrollCheck')
          })
        })
        .catch(function (response) {
          $scope.data.busy = false
          ErrorService.processError(response)
        })
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      _loadByRefresh()

      return _searchKeywords
    }

    function order(rowName) {
      if ($scope.data.row === rowName) {
        return
      }
      $scope.data.row = rowName
      _loadByRefresh()
    }

    function _loadByRefresh() {
      $scope.data.readonly_groups = []
      $scope.data.custom_groups = []
      _getQuickFilters()
      $scope.data.loadPromise = _loadGroups($scope.data.numPerLoad, 0)
    }

    function _getQuickFilters() {
      if (quickFiltersPromise) {
        PromiseService.cancelPromise(quickFiltersPromise)
      }

      quickFiltersPromise = groupsApiConfig.getQuickFilters(searchKeywords())

      quickFiltersPromise.then(
        function (response) {
          $scope.quickFilters = response.data.filters

          $scope.selectedQuickFilter = $scope.quickFilters.find(function (
            filter
          ) {
            return filter.filterType == $scope.selectedQuickFilter.filterType
          })
        },
        function (response) {
          ErrorService.processError(response)
        }
      )

      return quickFiltersPromise
    }

    function loadByScroll() {
      if (
        $scope.data.total_custom == 0 ||
        $scope.data.total_custom <= $scope.data.custom_groups.length
      ) {
        return
      }

      $scope.data.loadPromise = _loadGroups(
        $scope.data.numPerLoad,
        $scope.data.custom_groups.length
      )
    }

    function quickFilterSelect(filter) {
      $scope.selectedQuickFilter = filter
      _loadByRefresh()
    }

    function showAllApps(group) {
      group.limit = 'Infinity'
    }

    function deleteGroup(group) {
      return csTemplates
        .loadAndInterpolate(deleteGroupTemplateUrl, { groupName: group.name })
        .then(
          function (interpolatedStr) {
            var transl = {
              title_groupSettings_deleteGroup: $translate.instant(
                'title_groupSettings_deleteGroup'
              ),
              action_delete: $translate.instant('action_delete'),
              action_cancel: $translate.instant('action_cancel')
            }

            dialogs
              .confirm(
                transl.title_groupSettings_deleteGroup,
                interpolatedStr,
                {
                  size: 'sm',
                  yes: transl.action_delete,
                  no: transl.action_cancel
                }
              )
              .result.then(function () {
                groupsApiConfig.deleteGroup(group.group_id).then(
                  function (response) {
                    logger.logSuccess(response.data.messages[0])
                    _loadByRefresh()
                  },
                  function (response) {
                    ErrorService.processError(response)
                  }
                )
              })
          },
          function () {
            logger.logError('Unable to load confirm dialog')
          }
        )
    }

    init()
  }
})()
